import React, { useEffect } from 'react';
import { redirectAppToUrl } from 'utils';
import { getApiUrl } from '../../api/helpers';
import { ApiRoutes, RouteList } from 'types';
import { CircularProgress, Grid } from '@mui/material';

export const ResetPassword = () => {
  useEffect(() => {
    redirectAppToUrl(
      `${getApiUrl({ path: ApiRoutes.ResetPassword })}?redirectTo=${window.location.origin}${RouteList.Home}`
    );
  }, []);

  return (
    <Grid container height="100vh">
      <CircularProgress sx={{ m: 'auto auto' }} />
    </Grid>
  );
};
